import { render } from "./SkeletonText.vue?vue&type=template&id=3e9b8b6c&ts=true"
import script from "./SkeletonText.vue?vue&type=script&lang=ts"
export * from "./SkeletonText.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/SkeletonText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e9b8b6c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e9b8b6c', __exports__)) {
    api.reload('3e9b8b6c', __exports__)
  }
  
  module.hot.accept("./SkeletonText.vue?vue&type=template&id=3e9b8b6c&ts=true", () => {
    api.rerender('3e9b8b6c', render)
  })

}


export default __exports__